import Hero from '../components/Hero'
import MarketsGrid from '../components/MarketsGrid'
import ChartPanel from '../components/ChartPanel'
import Services from '../components/Services'
import WhyOrbix from '../components/WhyOrbix'
import Testimonials from '../components/Testimonials'
import ContactForm from '../components/ContactForm'

export default function Home() {
  return (
    <main>
      <Hero />
      {/* <MarketsGrid limit={6} /> */}
      {/* <ChartPanel /> */}
      <WhyOrbix />
      <Services />
      <Testimonials />
      <ContactForm />
    </main>
  )
}

